require('./pfmBarChart.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const {
    ComposedChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    Line,
} = require('recharts');
const moment = require('moment');
const { LINE_CHART_COLOR } = require('constants/charts');

// @Helpers
const { getCurrencySymbol } = require('utilities/currencyHelper');

// @components
const ChartTooltip = require('./chartTooltip/chartTooltip');
const XTick = require('./xTick/xTick');

class PfmBarChart extends React.Component {
    constructor(props) {
        super(props);

        this.buildStackedChart = this.buildStackedChart.bind(this);
        this.getCountLastYearData = this.getCountLastYearData.bind(this);
    }

    getCountLastYearData(chartData) {
        const lastYear = moment()
            .subtract(1, 'year')
            .format('YYYY');
        let count = 0;
        chartData.map(data => {
            if (data.year === parseInt(lastYear)) {
                count += 1;
            }
        });
        return count;
    }

    // Function to build stackedBar chart. We can include a boolean to create a simple barchart
    buildStackedChart(
        chartData,
        dataKeyBar,
        type,
        interval,
        periodTime,
        currency,
        lineChart,
        compareCharts,
    ) {
        const compareYears = compareCharts;
        const chartDataShow = chartData;
        const moneyObj = { currency: currency };
        const currencySymbol = getCurrencySymbol(moneyObj);
        return (
            <ResponsiveContainer width="100%" height="100%">
                <ComposedChart
                    data={chartDataShow}
                    margin={{ top: 10, right: 0, left: 0, bottom: 10 }}
                >
                    <XAxis
                        tickLine={false}
                        dataKey="name"
                        interval={interval}
                        tickMargin={20}
                        tick={
                            <XTick
                                periodTime={periodTime}
                                countLastYear={this.getCountLastYearData(
                                    chartData,
                                )}
                            />
                        }
                    />
                    <YAxis tickLine={false} unit={` ${currencySymbol}`} />
                    <CartesianGrid strokeDasharray="3 3" />
                    <Tooltip
                        cursor={{
                            strokeWidth: `${100 / chartData.length}%`,
                            strokeColor: LINE_CHART_COLOR,
                            strokeOpacity: 0.4,
                        }}
                        content={
                            <ChartTooltip
                                hasDebit
                                hasCredit
                                type={type}
                                periodTime={periodTime}
                                currency={currencySymbol}
                            />
                        }
                    />
                    {dataKeyBar.map(keyBar => {
                        return (
                            <Bar
                                key={keyBar.name}
                                dataKey={keyBar.name}
                                stackId="a"
                                fill={keyBar.color}
                                fillOpacity={0.9}
                            />
                        ); // different bars using keyBar configuration object
                    })}
                    {compareYears && (
                        <Line
                            key="TotalLastYear"
                            dataKey="TotalLastYear"
                            type="monotone"
                            stroke={LINE_CHART_COLOR}
                            strokeWidth={3}
                        />
                    )}
                </ComposedChart>
            </ResponsiveContainer>
        );
    }

    render() {
        const {
            chartData,
            dataKeyBar,
            type,
            interval,
            periodTime,
            currency,
            lineChart,
            compareCharts,
            hasDebit,
            hasCredit,
        } = this.props;
        return (
            <div className="ok-bar-chart-container col-xs-12 col-md-12">
                {this.buildStackedChart(
                    chartData,
                    dataKeyBar,
                    type,
                    interval,
                    periodTime,
                    currency,
                    lineChart,
                    compareCharts,
                    hasDebit,
                    hasCredit,
                )}
            </div>
        );
    }
}

PfmBarChart.propTypes = {
    chartData: PropTypes.array.isRequired,
    dataKeyBar: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
    interval: PropTypes.number,
    periodTime: PropTypes.string,
    currency: PropTypes.string,
    lineChart: PropTypes.obj,
    compareCharts: PropTypes.bool,
    hasDebit: PropTypes.bool,
    hasCredit: PropTypes.bool,
};

module.exports = PfmBarChart;
